/**
 * Grail core behaviour, shared by every page: holo sheen and card tilt that
 * follow the pointer, disclosure menus (close on outside click / Escape), and
 * pause buttons for moving content. Page-specific behaviour ships as custom
 * elements in their own asset files (product.js, collection.js, cart.js,
 * search.js), loaded only by the sections that use them.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------- Holo sheen + tilt ---------------- */
  // One listener for every tile: sets --mx/--my (sheen position), --sx (foil
  // sweep) and --rx/--ry (tilt) on the hovered media element.
  document.addEventListener('pointermove', (event) => {
    if (reduceMotion.matches || event.pointerType !== 'mouse') return;
    const media = event.target.closest?.('[data-tilt]');
    if (!media) return;
    const rect = media.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width;
    const y = (event.clientY - rect.top) / rect.height;
    media.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`);
    media.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
    media.style.setProperty('--sx', `${(x * 100).toFixed(1)}%`);
    media.style.setProperty('--rx', `${((0.5 - y) * 8).toFixed(2)}deg`);
    media.style.setProperty('--ry', `${((x - 0.5) * 10).toFixed(2)}deg`);
  });

  document.addEventListener(
    'pointerleave',
    (event) => {
      const media = event.target.closest?.('[data-tilt]');
      if (!media) return;
      ['--rx', '--ry'].forEach((prop) => media.style.setProperty(prop, '0deg'));
    },
    true
  );

  /* ---------------- Disclosures ---------------- */
  // <details data-disclosure> menus, dropdowns and panels close on outside
  // click and Escape (focus returns to their summary).
  document.addEventListener('click', (event) => {
    document.querySelectorAll('details[data-disclosure][open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const open = event.target.closest?.('details[data-disclosure][open]') || document.querySelector('details[data-disclosure][open]');
    if (!open) return;
    open.removeAttribute('open');
    open.querySelector('summary')?.focus();
  });

  /* ---------------- Motion pause buttons ---------------- */
  // A [data-motion-toggle] button pauses the nearest [data-motion] region
  // (WCAG 2.2.2); CSS reads [data-paused].
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-motion-toggle]');
    const root = toggle?.closest('[data-motion]');
    if (!root) return;
    const paused = !root.hasAttribute('data-paused');
    root.toggleAttribute('data-paused', paused);
    toggle.setAttribute('aria-pressed', String(paused));
  });
})();
